import React, { FC } from 'react';
import { DEFAULT_LANGUAGE, useLanguage, Language } from './useLanguage';
import classNames from 'classnames';
import LanguageIcon from '@mui/icons-material/Language';

interface LanguageOption {
    shortName: Language;
    name: string;
}

const LanguageOptions: LanguageOption[] = [
    { shortName: DEFAULT_LANGUAGE, name: 'English' },
    { shortName: 'fr', name: 'Français' },
];

export const LanguageSelector: FC<{ wrapperClass?: string }> = ({ wrapperClass = 'btn-flat-primary' }) => {
    const { selectedLanguage, changeSelectedLanguage } = useLanguage();

    return (
        <div className="btn-group">
            <button
                className={classNames('btn btn-icon-start dropdown-toggle pe-2 gap-0 text-uppercase', wrapperClass)}
                type="button" id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <LanguageIcon className="pe-2" />
                {selectedLanguage}
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                {LanguageOptions.map((item) => (
                    <button
                        key={item.shortName}
                        className={classNames('dropdown-item pe-auto', { 'active': selectedLanguage === item.shortName })}
                        role="option"
                        onClick={() => changeSelectedLanguage(item.shortName)}
                        aria-selected={selectedLanguage === item.shortName}
                        tabIndex={0}
                    >
                        {item.name}
                    </button>
                ))}
            </div>
        </div>
    );
};
